// Header.jsx - Minimal, fixed, with hamburger menu
import React, { useState, useEffect } from 'react';
import './Header.css';

const NAV_LINKS = [
  { label: 'Features', href: '/features' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Developers', href: '/developers' },
  { label: 'Docs', href: '/docs' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <header className={`landing-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="header-content">
          <a href="/" className="logo-link">
            <img 
              src="/images/flux_uro_logo_with_text_white_inline.png" 
              alt="URO" 
              className="logo-image"
            />
          </a>

          <div className="header-nav-desktop">
            {NAV_LINKS.map((link) => (
              <a key={link.label} href={link.href} className="header-nav-link">
                {link.label}
              </a>
            ))}
            <button 
              className="header-signin"
              onClick={() => window.location.href = 'https://account.fluxuro.ai'}
            >
              Sign in
            </button>
          </div>

          <div className="header-mobile-actions">
            <button 
              className="header-signin mobile-signin-btn"
              onClick={() => window.location.href = 'https://account.fluxuro.ai'}
            >
              Sign in
            </button>
            <button 
              className="hamburger-btn"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`} />
              <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`} />
              <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`} />
            </button>
          </div>
        </div>
      </header>

      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          {NAV_LINKS.map((link) => (
            <a 
              key={link.label} 
              href={link.href} 
              className="mobile-nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <button 
            className="btn-primary mobile-signin"
            onClick={() => window.location.href = 'https://account.fluxuro.ai'}
          >
            Sign in
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;
